
import * as React from 'react';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PublicIcon from '@mui/icons-material/Public';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';
import logo from "../pics/logo.png";

const isProd = process.env.REACT_APP_ENV === 'prod';

const categories = [
  {
    id: 'Menu',
    children: [
      { id: 'FDDPR Trigger', icon: <PublicIcon />, hidden: isProd },
      { id: 'Dashboard', icon: <DashboardIcon />, hidden: !isProd },
      { id: 'FDDPR Logs', icon: <PeopleIcon /> },
      { id: 'Download Results', icon: <DnsRoundedIcon /> }
    ],
  }
];

const item = {
  py: '12px',
  px: 1,
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover, &:focus, &:active': {
    bgcolor: 'rgba(255, 255, 255, 0.08)',
    transition: 'background-color 0.3s ease',
  },
};

const activeItem = {
  color: 'white',
  bgcolor: 'rgba(255, 255, 255, 0.08)',
  fontWeight: 'bold'
};

export default function Navigator(props) {
  const { onNavigate, ...other } = props;
  const [active, setActive] = React.useState("Dashboard");

  const handleClick = (childId) => {
    setActive(childId);
    onNavigate(childId);
  };

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <img
          src={logo}
          alt="Logo"
          style={{ width: '190px', height: 'auto', position: 'relative', left: '30px', top: '20px' }}
        />
        {categories.map(({ id, children }) => (
          <Box key={id} sx={{  mt: '4rem' }}>
            {children
              .filter((child) => !child.hidden)
              .map(({ id: childId, icon }) => (
                <ListItem disablePadding key={childId} sx={{bgcolor: active === childId ? 'white' : '#1a0251', margin:'10px', borderRadius: "8px", width: "235px"}}>
                  <ListItemButton
                    sx={active === childId ? { ...item, ...activeItem } : item}
                    
                    onClick={() => handleClick(childId)}
                  >
                    <ListItemIcon sx={{ color: active === childId ? '#1a0251' : 'white', marginLeft:'15px' }}>
                      {icon}
                    </ListItemIcon>
                    <ListItemText sx={{color: active === childId ? '#1a0251' : 'white',}}>{childId}</ListItemText>
                  </ListItemButton>
                </ListItem>
              ))}
          </Box>
        ))}
      </List>
    </Drawer>
  );
}
